<template>
    <div class="panel">
        <!-- 该区域用于不需要进度条等控件的情形,用于点击视频控制播放暂停 -->
        <!-- <div
            v-show="!controls"
            class="shadow-bg"
            @click="videoHandle(false)"
        >
            <img v-show="showPlayBtn" class="player" :src="playBtn" alt="播放">
        </div> -->
        <!-- 有合成好的视频的话，直接播合成好的视频 -->
        <video
            :id="tagIndex"
            :class="['oss-work-video', videoBorder]"
            :controls="controls"
            controlsList="nodownload"
            preload="auto"
            :loop="loop"
            :autoplay="autoplay"
            webkit-playsinline="true"
            playsinline="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portraint"
            :src="src"
            @play="videoPlay"
            @ended="myVideoEnded"
        >
            暂无作品
        </video>
        <div v-show="!autoplay && videoPanelShow" class="video-panel" @click="handerVideo">
            <img v-if="poster" class="poster" :src="poster" style="object-fit: cover;" alt="封面图">
            <div class="vlayer"></div>
            <img class="player" :src="playBtn" :style="{top: playBtnInCenter ? '50%' : '42%'}" alt="播放">
        </div>
    </div>
</template>
<script>
import {isAndroid} from '@/utils/utils';

export default {
    name: 'Myvideo',
    props: {
        tagIndex: {
            type: Number,
            default: 0
        },
        playBtn: {
            type: String,
            default() {
                return 'https://i.gsxcdn.com/1786511364_slpd7ee9.png';
            }
        },
        playBtnInCenter: {
            type: Boolean,
            default: true
        },
        src: {
            type: String,
            default: ''
        },
        poster: {
            type: String,
            default: ''
        },
        controls: {
            type: Boolean,
            default: true
        },
        loop: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // oAudio: null,
            // workVideo: null,
            videoBorder: '',
            videoPanelShow: true,
            // showPlayBtn: true,
            // ismuted: true
        };
    },
    mounted() {
        // 安卓手机上 video 总是不能被遮住，不再配置 border-radius 圆角
        this.videoBorder = isAndroid() ? 'no-bdr' : '';
        // this.oAudio = document.querySelector('#report-audio');
        this.ossworkVideo = document.querySelector('.oss-work-video');
    },
    methods: {
        handerVideo(e) {
            // this.$emit('gioreport');
            const tagIndex = e.srcElement.parentNode.parentNode.getElementsByTagName('video')[0].id;
            document.getElementById(tagIndex).play();
            // this.$emit('changevideopaused', this.ossworkVideo.paused);
        },
        // 控制视频的播放暂停
        // videoHandle() {
        //     // this.$utils.logNative({
        //     //     text: '进入操作视频播放状态的videoHandle方法;',
        //     //     content: `查看当前的播放状态:${this.ossworkVideo.paused}`
        //     // });
        //     if (!this.ossworkVideo) {
        //         return;
        //     }
        //     if (this.ossworkVideo.paused) {
        //         this.ossworkVideo.play();
        //         this.showPlayBtn = false;
        //     }
        //     else {
        //         this.ossworkVideo.pause();
        //         this.showPlayBtn = true;
        //     }
        //     // this.$utils.logNative({
        //     //     content: `操作视频播放状态之后查看当前的播放状态:${this.ossworkVideo.paused}`
        //     // });
        //     this.$emit('changevideopaused', this.ossworkVideo.paused);
        // },
        myVideoEnded(e) {
            this.videoPanelShow = true;
            // this.showPlayBtn = true;
        },
        pauseVideo() {
            // this.ossworkVideo && this.ossworkVideo.pause();
            // this.workVideo && this.workVideo.pause();
            const allVideos = document.querySelectorAll('.oss-work-video');
            const arr = [...allVideos];
            arr.forEach(item => {
                item.pause();
            });
        },
        videoPlay(e) {
            // this.$utils.logNative({
            //     text: '调用play方法开始播放视频',
            // });
            // this.ismuted = false;
            // this.showPlayBtn = false;
            this.videoPanelShow = false;
            const allVideos = document.querySelectorAll('.oss-work-video');
            const arr = [...allVideos];
            arr.forEach(item => {
                if (item.id != e.srcElement.id) {
                    item.pause();
                }
            });
            this.$emit('stop-other');
            // this.oAudio && this.oAudio.play();
        },
        // videoPause(e) {
        //     this.oAudio.pause();
        // },
        // videoSeeked(e) {
        //     if (this.oAudio) {
        //         this.oAudio.currentTime = e.srcElement.currentTime;
        //         this.oAudio.play();
        //     }
        // },
        // videoTimeupdate(e) {
        //     const {oAudio} = this;

        //     if (oAudio && oAudio.paused) {
        //         try {
        //             oAudio.currentTime = e.srcElement.currentTime;
        //             oAudio.play();
        //         }
        //         catch (err) {
        //             console.log('err', err);
        //         }
        //     }
        // },
        // audioTimeupdate(e) {
        // },
        // videoLoadedmetadata(e) {
        //     console.log('videoLoadedmetadata', e.srcElement.duration);
        // },
        // videoEnded(e) {
        //     e.srcElement.play();
        //     this.oAudio.currentTime = 0;
        //     this.oAudio.play();
        // },
        // audioEnded(e) {
        // }
    }
};
</script>
<style lang="scss" scoped>
.panel {
    overflow: hidden;
    // border: .107rem solid #efb68d;
    border-radius: .42rem;

    // .shadow-bg {
    //     position: absolute;
    //     width: 100%;
    //     height: 100%;
    //     left: 0;
    //     top: 0;
    //     z-index: 3;

    //     .player {
    //         position: absolute;
    //         z-index: 20;
    //         left: 50%;
    //         top: 50%;
    //         transform: translate(-50%, -50%);
    //         width: 1.893rem;
    //         height: 1.893rem;
    //     }
    // }

    // .work-video,
    .oss-work-video {
        width: 100%;
        height: 100%;
        // background: #fffcf9;
        // border-radius: .34rem;
    }

    .no-bdr {
        border-radius: unset;
    }

    .video-panel {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        overflow: hidden;
        box-sizing: border-box;

        .poster {
            width: 100%;
            height: 100%;
            // background: #fffcf9;
            // border-radius: .34rem;
        }

        .vlayer {
            position: absolute;
            z-index: 10;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            // border-radius: .34rem;
            background: #000;
            opacity: .3;
            transform: translateZ(11px);
        }

        .player {
            position: absolute;
            z-index: 20;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 1.85rem;
            height: 1.84rem;
        }
    }
}
</style>
